var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.7 23.7",
    style: {
      enableBackground: "new 0 0 23.7 23.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M16.4,11.2h-3.9V7.3c0-0.3-0.3-0.6-0.6-0.6S11.2,7,11.2,7.3v3.9H7.3c-0.3,0-0.6,0.3-0.6,0.6 c0,0.3,0.3,0.6,0.6,0.6h3.9v3.9c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6v-3.9h3.9c0.3,0,0.6-0.3,0.6-0.6 C17,11.5,16.7,11.2,16.4,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M11.9,0C5.3,0,0,5.3,0,11.9c0,6.5,5.3,11.9,11.9,11.9s11.8-5.3,11.8-11.9C23.7,5.3,18.4,0,11.9,0z M11.9,22.5 C6,22.5,1.2,17.7,1.2,11.9S6,1.2,11.9,1.2c5.9,0,10.6,4.8,10.6,10.6S17.7,22.5,11.9,22.5z"
  }))), "s\n");
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.f01c2399.svg";
export { ForwardRef as ReactComponent };